
import { parseJson, stringifyJson } from '../utilities/JsonUtils';
import { AccordionData } from '../commonComponent/AccordionsComponent';
import { FileSizeUnit, TextType } from './Constants';
import { Column } from 'primereact/column';
import { getRootComponent } from '../utilities/ElementUtils';
import { FormEntity } from './FormEntity';
export abstract class BaseType {
    Id: string;
    ENUTitle: string;
    ENUDescription: string;
    FRATitle: string;
    FRADescription: string;
    RecordType: string;
    Sequence: number;
    enuToolTip: string;
    fraToolTip: string;

    // visible: boolean = true;

    copyTo(copy: BaseType): void {
        copy.Id = this.Id;
        copy.ENUTitle = this.ENUTitle;
        copy.FRATitle = this.FRATitle;
        copy.Sequence = this.Sequence;
        copy.enuToolTip = this.enuToolTip;
        copy.fraToolTip = this.fraToolTip;
        // copy.visible = this.visible;
    }
    toInfoString() {
        return `Id:${this.Id}, Title:${this.ENUTitle}}`;
    }
}

/* ExtensionField Tags */
export abstract class BaseWithExtension extends BaseType {
    EGMSStyle: string;
    parent: BaseType = null;
}

export class FormSectionElements extends BaseWithExtension {
    Sequence: number;
    Datatype: string;
    Editable: string;
    Optional: string;
    Valid: boolean;
    Visible: boolean;
    parent: any; // Adjust to correct type if available
    findFieldByName: (fieldName: any) => any;
    findSectionByTitle: (sectionTitle: any) => any;
    StaticDropdownReference: string;
    LoadBindName: string;
    // EntityType:string;
    LoadBindBase: string;
    Length: string;
    RecordName: string;
    SubSectionId: string;
    TooltipENU: string;
    TooltipFRA: string;
    Type: string;
    day: string;
    month: string;
    year: string;
    Value;
    ENUValidateTitle: string;
    FRAValidateTitle: string;
    Language: string;
    converted: boolean;
    fieldValue: string; // input value holder
    FilterField;
    FilterValue;
    FilterFieldFRA;
    FilterValueFRA;
    FilterCompareMethod: string;
    ValidateCompareMethod: string;
    ValidateCompareField: string;
    ValueType: string;//when readonly, constant or calculated
    DecidingField1;
    CalculationMethod: string
    DecidingField2
    MeasurementUnit: string;
    HasSummaryRow: string;
    HasTotalColumn: string;
    FreezeColumn: string;
    HasGrandTotal: string;
    TableMenuRows?: any[];
    CMADashboard?: boolean;
    CMAQuestionComment?: string;
    ListOfLOVValues: LOVValues[];
    ListOfExpectedValues: any[];
    ListOfReplacements: { [key: string]: any };
    accordions?: { expandAll: boolean; accordions: AccordionData[]; };
    accordionsFRA?: { expandAll: boolean; accordions: AccordionData[]; };
    summaryFromFlow?: boolean;
    Api: string;
    apiErrorRedirectPage?: number;
    ForRole: string;
    subSectionList: FormSubSections[];
    counterVisible: boolean;
    HasAddButton: string;
    DisplayTooltipValue: string;
    Script: string;
    ScriptTriggerField: string;
    ScriptTriggerFieldValue: string;
    AffectedField: string;
    EnabledByField: string;
    EnabledByFieldValue: string;
    OnOff: string;
    MustHaveTrueValueInTable: string;
    Hint: string;
    HintFR: string;
    UpdateField: string;
    colWidth: string;
    filterDisplay: string;
    ErrorMessage: string;
    ErrorMessageFRA: string;
    callOutBoxType: string;
    callOutBoxTitle: string;
    callOutBoxTitleFRA: string;
    callOutBoxBody: string;
    callOutBoxBodyFRA: string;
    hintExpansionTitle: string;
    hintExpansionTitleFRA: string;
    AttachmentList;
    Touched: boolean;
    RegularExpression: string;
    wrapCalloutbox: string;
    MessageTitle: string;
    MessageTitleFRA: string;
    MessageBody: string;
    MessageBodyFRA: string;
    ConfirmationEmail: string;
    AddEmptyItemToList: string;
    Checked: boolean;
    SelectionCode: string;
    ValueFRA: string;
    getAPI: string;
    richTextChecked: boolean;
    PCLookupUrl: string;
    AddressLookupUrl: string;
    MinValue: any;
    MaxValue: any;
    Address: any;
    addressType?: AddressType;
    TextType?: TextType;
    mailingSameAsResidential: boolean;
    showMailingDetails: boolean;
    mask: boolean;
    Recaptcha?: { action: string; content?: {en?: string; fr?: string;}, handlerName?: string; api?: string; };
    displayInEditor:boolean;
    ClassName ;
    FileUpload: { AllowedForUploadFileTypeList: UploadFileType[]; PreviewFile?: boolean; hasDescription?: boolean, LegacyStyle?: boolean; FileSizeLimit?: number; SizeUnite?: FileSizeUnit};
    EmptyErrorMessage: string;
    EmptyErrorMessageFRA: string;
    IsEmpty:boolean;
    MaskInSummary: boolean;
    triggerSubmitOnEnter: boolean;
    InitScript: string;
    ReadOnly: boolean;
    LovAPI: string;
    StepperScript: string;
    FieldMustBeAtTop: boolean;
    ErrorContentValueFRA: string;
    ErrorContentValue: string;
    feedback?: { status?: string; code?: string; }
    inlineStyling: boolean;
    ValidateStep: string;
    SubmissionMethod: any;
    ErrorMessageRichText: string;
    ErrorMessageRichTextFRA: string;
    Columns: TableColumn[];
    FeedbackURL_CXP: string;
    FeedbackURL: string;
    FeedbackURLFRA: string;
    FeedbackURLFRA_CXP: string;
    KeyStrokeScript: any;
    Gap: string;
   
      // Define the method findFieldByName
  

    clone(): FormSectionElements {
        let copy: FormSectionElements = new FormSectionElements();

        super.copyTo(copy);

        copy.Datatype = this.Datatype;
        copy.Editable = this.Editable;
        copy.Value = this.Value;
        copy.ListOfLOVValues = this.ListOfLOVValues;

        // copy.labelVisible = this.labelVisible;
        // copy.valueAsLabel = this.valueAsLabel;
        copy.fieldValue = this.fieldValue;
        return copy;
    }

    clearValue(): FormSectionElements {
        let copy: FormSectionElements = new FormSectionElements();

        super.copyTo(copy);

        copy.Datatype = this.Datatype;
        copy.Editable = this.Editable;
        copy.Value = "";
        copy.ListOfLOVValues = this.ListOfLOVValues;

        // copy.labelVisible = this.labelVisible;
        // copy.valueAsLabel = this.valueAsLabel;
        copy.fieldValue = this.fieldValue;
        return copy;
    }
}

export class CMAScore {
    label: string;
    labelFRA: string;
    level: number;
    definition: string;
    KPMGdefinition: string;
    toolTip: string;
}

export class FormButtons {
    Label: string;
    Status: string;
    Api: string;
    Icon: string;
    Script: string;
    VisibleStatus: string;
    ForRole: string;
    BackButton: string;
}

export class CallOutBox {
    CalloutType: string;
    Title: string;
    BodyMsg: string;
    Status: string;
    Script: string;
    VisibleStatus: string;
}

export class FormSubSectionFilter {
    ListOfFormSectionElements: FormSectionElements[] = [];
    ListOfButtons: FormButtons[];
}

export class FormSubSections extends BaseWithExtension {
    SectionId: string;

    ListOfFormSectionElements: FormSectionElements[] = [];
    ListOfFormChildSection: FormSubSections[];
    RoleHasAddbutton: string;
    HasPopup: string;
    ButtonLabel: string;
    EntityType: string
    WithinTab: string;
    Api: string;
    Datasource: string;
    ListOfButtons: FormButtons[];
    ForRole: string;
    OrderBy: string;
    EditableStatus: string;
    OwnerEditableOnly: string;
    HasTotalColumn: string;
    parent;
    NoCardInSummary:boolean;
    // Repeatable:string;
    // FilterListOfFormSectionElements:  FormSectionElements[]=[];
    // FilterListOfFormSectionButtons:  FormButtons[]=[];
    Paging: string;
    Visible: boolean;
    clone(): FormSubSections {
        const root = getRootComponent(this);
        return parseJson(stringifyJson(this, root.CategoryId), root.CategoryId);
    }
}

/* Finding FormSections using ExtensionField1 */
export class FormSections extends BaseWithExtension {
    ListOfFormSubSections: FormSubSections[];
    ListOfButtons: FormButtons[];
    ForRole: string;
    ReferencedFormSectionID: string;
    EntityType: string;
    GetAPI: string;
    UpdateAPI: string;
    DeleteAPI: string;
    Value;
    CustomizedReviewPage: boolean;
    CustomizedStyle?: SummaryStyleType;
    FilterField;
    FilterValue;
    FilterValueFRA;
    Visible: boolean;
    IsFrontPage: boolean;
    IsTerminationPage: boolean;
    parent: any;
    NotStep: boolean;
    PreScript: string;
    PostScript: string;
    IsTechErrorPage: boolean;
    stepTitle?: string;
    stepTitleFRA?: string; 
    // IsTerminalSection:boolean;
    NoTotalPages: boolean;
    NoStepIndicator: boolean;
    IsInfoPage: boolean;
    findFieldByName: (fieldName: any) => any;
    findSubsectionByTitle: (fieldName: any) => any;
    findSectionByTitle: (sectionTitle: any) => any;
    IsConfirmationPage: boolean;
    TitleInStepIndicator: boolean;
    NextButtonLabel:string;
    NextButtonLabelFRA:string
    GetToken: string;
    BackButtonLabel: string;
    BackButtonLabelFRA: string;
    BackButtonURLFRA: string;
    BackButtonURL: string;
    Dynamic: boolean;
    // Stepper: FormSectionStepper;
}

export class FormSectionStepper {
    stepTitle?: string;
    stepTitleFRA?: string;
    NotStep: boolean;
    NoStepIndicator: boolean;
    NoTotalPages: boolean;
    stepHome: boolean;
}

/**
 * Top level Form Template holder
 */
export class ProgramContainer {
    id: string;
    Name: string;
    NameFRA: string;
    CategoryId: string;
    ReportBackType: string;
    ReportBackName: string;
    AppTitle?: {en?: string; fr?: string;};
    Instructions: string;
    Declaration: string;
    ListOfFormSections: FormSections[];
    UpdateAPI: string;
    GetAPI: string;
    DeleteAPI: string;
    CreateAPI: string;
    IntObjectName: string;
    APIBasePath: string;
    AuthRequired: string;
    displayForm: string;
    ForSiebel: string;
    pdfTemplate: string;
    HasSaveDraftButton: string;
    CheckboxValueYN: string;
    UseProxy: string;
    UseAsterisks: string;
    NoReview: string;
    sendPageDataToGA: boolean;
    GATrackingID: string;
    RedirectURL: string;
    RedirectURLFRA: string;
    HeaderType: string;
    OntarioChat: boolean;
    NoClearButton: string;
    SocialMedia: any;
    // DisableJavascript:boolean;
    Profile: any;
    TimeoutPopup: boolean;
    Deployed: boolean;
    createdById: string;
    IsComplete: boolean
    EnglishOnly: boolean;
    HelpOption: boolean;
    HelpRichText: string;
    HelpRichTextFRA: string;
    HelpHeader: string;
    HelpHeaderFRA: string;
    HelpFooter: string;
    HelpFooterFRA: string;
    DecryptPDFPassword: string;
    Coowners: any[];
    FeedbackURLFRA_CXP: string;
    FeedbackURL_CXP: string;
    FeedbackURLFRA: string;
    FeedbackURL: string;
    CMAOptionList?: CMAScore[];
    MinistryOptions: LOVValues[];
    SectorOptions: LOVValues[];
    ClusterOptions: LOVValues[];
    FunctionNameList: LOVValues[];
    Entity: FormEntity;
    CategoryNameList:LOVValues[];
    SubCategoryNameList: LOVValues[];
    OrganizationList: Organization[];
    CMATemplateList: CMATemplate[];
    Template: string;
    adminConfig?: AdminMessage;
    Creator:string;
    organizationName: string;
    HeaderConfig?: HeaderConfig;
    cmaComments?: CommentDetail[];
    orgId:number;
    userRole?: string;
    OriginURLFRA: string;
    OriginURL: string;
    Origin: string;
    OriginFRA: string;
}

export class Organization {
    Name: string;
    Address: string;
    Cluster: LOVValues;
    Ministry: LOVValues;
    Sector: LOVValues;
    Lead1;
    Lead2;
    CSPersonal;
    TechnologyOverview: string;
    SecurityOverview: string;
    Employees: number;
    ITDepartmentSize: number;
    SecurityDepartmentSize: number;
    CSEngagementLead;
    CSLead;
    EstimatedMaturityLevel: string;
    TargetMaturityLevel: string;
    AssessedMaturityLevel: string;
    Considerations: string;
    RemarksByEntity;
    RemarksByCS;
    Challenges: string;
    // Templates: CMATemplate[];
    Templates: string[];
}

export class CMATemplate {
    Name: string;
    Functions: FunctionDetail[]
}

export class FunctionDetail{
   FunctionName: string
   CategoryNameList: string[];
   CategoryDetailList: CategoryDetail[];
}

export class CategoryDetail {
    CategoryName: string;
    SubcategoryNameList: string[];
    CommentsList?: CommentDetail[];
}

export class CommentDetail{
    Comments: string;
    MadeOn: string;
    MadeBy: string;
    Resolved?: boolean;
    role?: 'A' | 'C';
    id?: string;
    func?: string;
    category?: string;
}

/*LOVValues tags */
export class LOVValues {
    id: string;
    Sequence: number;
    code: string;
    FRA: string;
    description: string;
    FRADescription: string;
    FilterField: string;
    FilterValue: string;
    FilterFieldFRA: string;
    FilterValueFRA: string;
    hintExpansionTitle: string;
    hintExpansionTitleFRA: string;
    callOutBoxType: string;
    callOutBoxTitle: string;
    callOutBoxTitleFRA: string;
    callOutBoxBody: string;
    callOutBoxBodyFRA: string;
    subItems: SubItem[];
    richText: string;
    richTextFRA: string;
    Script: string;
    Visible:boolean;
    parent: FormSectionElements;
}

export class SubItem {
    code: string;
    FRA: string;
}
export class AddressFieldSets {
    addressLine1: string;
    addressLine2: string;
    city: string;
    province: string;
    postalCode: string;
}

export interface FileType {
    mimeType: string;
    ext: string;
}

export interface UploadFileType {
    val: FileType[], 
    label: string,
}

export const ShowDebugInfo: boolean = true;

export type AddressType = 'Residential' | 'Mailing';

export type HtmlAttribute = {
    name: string;
    value: string;
}

export type ScriptSource = {
    location: 'Head' | 'BodyStart' | 'BodyEnd';
    source: string;
    type?: 'text/javascript' | 'module';
    attributes?: HtmlAttribute[];
    isAsync?: boolean;
    isDefer?: boolean;
}

export type TableColumn={
    returnIndex: number;
    className: string;
    header:string;
    columnType: string;
    JavaScript: string
}

export type SummaryStyleType = 'Button' | 'Link' | 'Table' | 'All';

export type API = {
    url: string;
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
    apiErrorRedirectPage?: string;
    apiSuccessRedirectPage?: string;
    responseCodeRoute?: { [key: string]: string } [];
}

export type ButtonType = {
    title: string;
    api?: API;
    recaptha?: { action: string; content?: {en?: string; fr?: string;}, handlerName?: string; api?: string; };
    nextRoute?: number;
}

export type AdminMessage = {
    messageContent?: string;
    messageType?: string;
    messageContentFrench?: string;
    isActive?: boolean;
    fromTime?: string;
    toTime?: string;
    reason?: string;
};

export type AzureGroupType = {
    "@odata.type": string,
    classification?: string|null,
    createdDateTime?: string,
    creationOptions?: string[],
    deletedDateTime?: string|null,
    description?: string|null,
    displayName: string|null,
    expirationDateTime?: string|null,
    groupTypes?: string[],
    id: string,
    isAssignableToRole?: string|null,
    mail?: string|null,
    mailEnabled?: boolean,
    mailNickname?: string|null,
    membershipRule?: string|null,
    membershipRuleProcessingState?: string|null,
    onPremisesDomainName?: string|null,
    onPremisesLastSyncDateTime?: string|null,
    onPremisesNetBiosName?: string|null,
    onPremisesProvisioningErrors?: any[],
    onPremisesSamAccountName?: string|null,
    onPremisesSecurityIdentifier?: string|null,
    onPremisesSyncEnabled?: boolean,
    preferredDataLocation?: string|null,
    preferredLanguage?: string|null,
    proxyAddresses?: string[],
    renewedDateTime?: string,
    resourceBehaviorOptions?: any[],
    resourceProvisioningOptions?: any[],
    securityEnabled?: boolean,
    securityIdentifier?: string|null,
    theme?: string|null,
    serviceProvisioningErrors?: any[],
    transitiveMemberOf?: string[],
    uniqueName?: string|null,
    visibility?: string|null,
}

export type AzureUser = {
    businessPhones?: string[],
    displayName: string,
    givenName: string,
    jobTitle: string,
    mail: string,
    mobilePhone?: string,
    officeLocation?: string,
    preferredLanguage?: string,
    surname: string,
    userPrincipalName: string,
    id: string,
}

export type HeaderConfig = {
    notification?: boolean;
    comments?: boolean;
    category?: string;
    func?: string;
}
